export default __webpack_public_path__ + "static/context-do-4-dark-d99fccd0a2424f94e37531d548f8b536.png";